import React, { useState } from 'react';
import styled from 'styled-components';
import { Paragraph } from '../../Paragraph/Paragraph';
import InfoIcon from '../assets/InfoIcon.png';

interface CardProps {
  image: string;
  title: string;
  description: string;
  info: string;
  color: string;
}

const PackCard: React.FC<CardProps> = ({ image, title, description, info, color }) => {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleOpen = () => {
    setVisible(true);
    setTimeout(() => setOpen(true), 10);
  };

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => setVisible(false), 300);
  };

  return (
    <Card>
      <ImageWrapper>
        <Image src={image} alt={title} />
      </ImageWrapper>
      <ContainWrapper>
        <CardTitle text={title} $highlightColor={color} />
        <CardDescription text={description} />
        <InfoButton onClick={handleOpen}>
          <img src={InfoIcon} alt='info' />
        </InfoButton>
      </ContainWrapper>

      {visible && (
        <Popover className={open ? 'open' : 'close'}>
          <CloseButton onClick={handleClose}>×</CloseButton>
          <PopoverText text={info} />
        </Popover>
      )}
    </Card>
  );
};

export default PackCard;

const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 300px;

  @media (min-width: 768px) {
    max-width: 500px;
  }

  @media (min-width: 1024px) {
    min-height: 700px;
  }
`;

const ContainWrapper = styled.div`
  display: flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

const ImageWrapper = styled.div`
  margin-bottom: 16px;

  @media (min-width: 768px) {
    margin-bottom: 24px;
  }

  @media (min-width: 1024px) {
    min-height: 354px;
    margin-bottom: 40px;
  }
`;

const Image = styled.img`
  width: 244px;
  height: auto;

  @media (min-width: 768px) {
    width: 426px;
  }

  @media (min-width: 1024px) {
    width: 450px;
  }
`;

const CardTitle = styled(Paragraph).attrs<{ $highlightColor?: string }>((p) => ({}))<{
  $highlightColor?: string;
}>`
  display: inline-block;
  position: relative;
  z-index: 1;
  font-size: 20px;
  font-weight: 700;
  color: #283288;
  margin-bottom: 20px;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 8px;
    width: 110%;
    max-width: 1000px;
    background-color: ${({ $highlightColor }) => $highlightColor};
    z-index: -1;
  }

  @media (min-width: 768px) {
    font-size: 35px;
    margin-bottom: 30px;

    &::after {
      height: 12px;
    }
  }
`;

const CardDescription = styled(Paragraph)`
  margin: 0;
  line-height: 16px;

  @media (min-width: 768px) {
    line-height: 30px;
    font-size: 20px;
  }

  @media (min-width: 1024px) {
    min-height: 150px;
  }
`;

const InfoButton = styled.div`
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 25px;

  img {
    width: 22px;
    height: 22px;
  }

  @media (min-width: 768px) {
    img {
      width: 30px;
      height: 30px;
    }
  }

  @media (min-width: 1024px) {
    margin-top: 45px;

    img {
      width: 38px;
      height: 38px;
    }
  }
`;

const Popover = styled.div`
  position: absolute;
  bottom: -2%;
  left: 50%;
  transform: translateX(-50%) scale(0.95);
  background: white;
  border-radius: 12px;
  padding: 40px;
  width: 335px;
  z-index: 10;

  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease;

  &.open {
    opacity: 1;
    transform: translateX(-50%) scale(1);
    pointer-events: auto;
  }

  &.close {
    opacity: 0;
    transform: translateX(-50%) scale(0.95);
    pointer-events: none;
  }

  @media (min-width: 768px) {
    width: 500px;
    padding: 55px 25px;
    bottom: -4%;
  }

  @media (min-width: 1024px) {
    width: 410px;
    padding: 45px 50px;
    bottom: -10%;
  }
`;

const PopoverText = styled(Paragraph)`
  font-size: 12px;
  line-height: 14px;

  @media (min-width: 768px) {
    font-size: 18px;
    line-height: 25px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -9%;
  right: -34%;
  border: none;
  background: none;
  font-size: 30px;
  font-weight: bold;
  cursor: pointer;
  color: #283288;

  @media (min-width: 768px) {
    top: -5%;
    right: -25%;
  }

  @media (min-width: 1024px) {
    top: -5%;
    right: -30%;
  }
`;
